var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('div',[_c('div',{staticClass:"translate-container",attrs:{"id":"google_translate_element"}}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }